import { render, staticRenderFns } from "./ManagementEntityContent.vue?vue&type=template&id=97f0a352&scoped=true&"
import script from "./ManagementEntityContent.vue?vue&type=script&lang=js&"
export * from "./ManagementEntityContent.vue?vue&type=script&lang=js&"
import style0 from "./ManagementEntityContent.vue?vue&type=style&index=0&id=97f0a352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f0a352",
  null
  
)

export default component.exports